import React from "react";
import "./stat_card.ui.scss";

interface IStatCard {
  label: string;
  value: string | number;
  delta?: number;
  icon?: React.ReactNode;
  footer?: string;
}

const StatCard = (props: IStatCard) => {
  const { label, value, delta, icon, footer } = props;
  const hasDelta = delta !== undefined && delta !== null;
  const isUp = hasDelta && delta >= 0;

  return (
    <div className="stat_card">
      <div className="stat_card_header" data-testid="stat_card_header">
        {icon && <div className="stat_card_icon">{icon}</div>}
        <span className="stat_card_label">{label}</span>
      </div>
      <span className="stat_card_value">{value}</span>
      {hasDelta && (
        <span
          data-testid="stat_card_delta"
          className={isUp ? "stat_card_delta_up" : "stat_card_delta_down"}
        >
          {isUp ? "▲" : "▼"} {Math.abs(delta as number)}
        </span>
      )}
      {footer && (
        <span data-testid="stat_card_footer" className="stat_card_footer">
          {footer}
        </span>
      )}
    </div>
  );
};

export default StatCard;
